class GNBToggleManager {
  constructor() {
    this.navbar = document.getElementById('global-navbar')
    this.toggle = this.navbar.querySelector('.gnb-toggle')
    this.toggled = this.navbar.classList.contains('toggled')
  }

  attach() {
    this.toggle.addEventListener('click', x => this.flip(x), false)
  }

  flip() {
    if (this.toggled) {
      this.navbar.classList.remove('toggled')
      document.body.classList.remove('noscroll')
    } else {
      this.navbar.classList.add('toggled')
      document.body.classList.add('noscroll')
    }

    this.toggled = !this.toggled
  }
}

let manager = new GNBToggleManager()
manager.attach()



// WEBPACK FOOTER //
// ./assets/js/index.js